const lang_en = {
  a: "Hello",
};

export default lang_en;
